import { render, staticRenderFns } from "./pagenotfound.vue?vue&type=template&id=0cf41638"
import script from "./pagenotfound.vue?vue&type=script&lang=js"
export * from "./pagenotfound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports